'use client';

import { useState } from 'react';
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { Button, Group } from "@mantine/core";
import classes from './News.module.scss';

export function Filters() {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const [currentFilter, setCurrentFilter] = useState(null);
    const currentType = searchParams.get('type');

    const handleFilter = (type) => {
        if (type) {
            router.push(`${pathname}?type=${type}`, { scroll: false});
            setCurrentFilter(type);
        } else {
            router.push(pathname, { scroll: false});
            setCurrentFilter(null);
        }
    }

    return (
        <Group className={classes.newsFilters} m={0}>
            <Button onClick={() => handleFilter()} color="violet" variant={(currentFilter !== null) || (currentType !== null) ? 'outline' : 'filled'}>All</Button>
            <Button onClick={() => handleFilter('News')} color="violet" variant={(currentFilter === 'News') || (currentType === 'News') ? 'filled' : 'outline'}>News</Button>
            <Button onClick={() => handleFilter('Event')} color="violet" variant={(currentFilter === 'Event') || (currentType === 'Event') ? 'filled' : 'outline'}>Events</Button>
            <Button onClick={() => handleFilter('Article')} color="violet" variant={(currentFilter === 'Article') || (currentType === 'Article') ? 'filled' : 'outline'}>Articles</Button>
        </Group>
    )
}
